module.exports = __webpack_public_path__ + "static/media/Zim-Welcome-sml_2.fdd51795.mp4";